import { render, staticRenderFns } from "./ModalServicos.vue?vue&type=template&id=00b2ddd6&scoped=true&"
import script from "./ModalServicos.vue?vue&type=script&lang=js&"
export * from "./ModalServicos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b2ddd6",
  null
  
)

export default component.exports